// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import {
  DefaultCardPickerItemProps,
  PlasmicCardPickerItem,
} from "@/wab/client/plasmic/plasmic_kit_component_props_section/PlasmicCardPickerItem";
import { HTMLElementRefOf } from "@plasmicapp/react-web";
import * as React from "react";

export interface CardPickerItemProps extends DefaultCardPickerItemProps {
  imgUrl: string;
  onClick: () => void;
}

function CardPickerItem_(
  props: CardPickerItemProps,
  ref: HTMLElementRefOf<"button">
) {
  const { imgUrl, onClick, ...rest } = props;

  return (
    <PlasmicCardPickerItem
      root={{
        ref,
        onClick: onClick,
      }}
      image={{
        render: (imageProps, Component) => (
          <Component {...imageProps}>
            <img
              src={imgUrl}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </Component>
        ),
      }}
      {...rest}
    />
  );
}

const CardPickerItem = React.forwardRef(CardPickerItem_);

export default CardPickerItem;
